import { NavLink } from 'react-router-dom';
import { havingPermission } from '../../../utils/PermissionMatching';

function SubmenuLink({ item, permissionAll }) {
    if (!havingPermission(item, permissionAll)) {
        return null;
    }

    return (
        <li key={item?.id} className="flex items-center mb-1 mt-1 -ml-px relative -z-0">
            <div className="line-vh h-12 absolute w-4 -top-7 left-0 bg-transparent border border-t-0 border-r-0 border-secondary-200 rounded-bl-md" />

            <NavLink
                to={`/${item.path}`}
                className="py-[7px] px-2.5 ml-4 hover:bg-secondary-100 w-full rounded-md transition-colors"
            >
                <span className="text-base font-normal capitalize text-primary-700">
                    {item.title}
                </span>
            </NavLink>
        </li>
    );
}

// Use for submenu inside of main menu item
export function SubMenuItem({ subMenu = [], isActive = false, permissionAll = [] }) {
    return (
        <ul
            className={`submenu-level-2 ml-5 transition-all pl-0.5 overflow-hidden duration-${
                subMenu?.length
            }00 ${isActive ? `max-h-76` : 'max-h-0'} `}
        >
            {subMenu?.map((item) => (
                <SubmenuLink key={item?.id} item={item} permissionAll={permissionAll} />
            ))}
        </ul>
    );
}

function SubMenu() {
    return null;
}

export default SubMenu;
